import React, { useEffect, useRef } from 'react';
import { flameSprite, drawGasBlob } from '../../utils/emberPalette';
const IrisEmberBurst = ({ onDone }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const w = window.innerWidth;
    const h = window.innerHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    const cx = w / 2;
    const cy = h / 2;
    const N = window.innerWidth <= 768 ? 50 : 110;
    const parts = Array.from({ length: N }, () => {
      const ang = Math.random() * Math.PI * 2;
      const z = 0.5 + Math.random() * 1.1;
      const speed = (2.5 + Math.random() * 7) * z;
      return {
        x: cx,
        y: cy,
        vx: Math.cos(ang) * speed,
        vy: Math.sin(ang) * speed,
        life: 0,
        maxLife: 40 + Math.random() * 45,
        r: (0.6 + Math.random() * 1.8) * z,
        curl: (Math.random() < 0.5 ? -1 : 1) * (0.25 + Math.random() * 0.4),
        tw: Math.random() * Math.PI * 2,
        tws: 0.07 + Math.random() * 0.09,
        trail: [{ x: cx, y: cy, j: 0 }],
      };
    });

    let raf;
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      let alive = 0;
      for (const p of parts) {
        if (p.life > p.maxLife) continue;
        alive += 1;
        p.tw += p.tws;
        const sp = Math.hypot(p.vx, p.vy) || 1;
        const wob = Math.sin(p.tw) * p.curl;
        p.vx += (-p.vy / sp) * wob;
        p.vy += (p.vx / sp) * wob;
        p.vx *= 0.985;
        p.vy *= 0.985;
        p.x += p.vx;
        p.y += p.vy;
        const j = p.life / p.maxLife;
        p.trail.push({ x: p.x, y: p.y, j });
        if (p.trail.length > 6) p.trail.shift();
        p.life += 1;
        const a = (1 - p.life / p.maxLife) * 0.7;
        const ang = Math.atan2(p.vy, p.vx);
        for (let t = 0; t < p.trail.length; t++) {
          const tp = p.trail[t];
          const tf = (t + 1) / p.trail.length;
          drawGasBlob(ctx, flameSprite(tp.j), tp.x, tp.y, p.r * 8 * (0.5 + 0.5 * tf), ang, 2.2, a * tf);
        }
      }
      if (alive > 0) {
        raf = requestAnimationFrame(tick);
      } else {
        onDone && onDone();
      }
    };
    tick();
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return <canvas ref={canvasRef} className="xp-iris-burst" aria-hidden="true" data-testid="xp-iris-burst" />;
};

export default IrisEmberBurst;
